/* Newsletter Bellucco: richiesta con consenso e conferma via email. */
(() => {
  const bind = () => {
    document.querySelectorAll('[data-bb-newsletter]').forEach(form => {
      if (form.dataset.bound === 'true') return;
      const email = form.querySelector('[name="email"]');
      const consent = form.querySelector('[name="consent"]');
      const submit = form.querySelector('[type="submit"]');
      const status = form.querySelector('[data-newsletter-status]');
      const fields = form.querySelector('[data-newsletter-fields]');
      const success = form.querySelector('[data-newsletter-success]');
      if (!email || !consent || !submit || !status || !fields || !success) return;
      form.dataset.bound = 'true';
      let busy = false;
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || !success.hidden || !form.reportValidity() || !consent.checked) return;
        busy = true;
        submit.disabled = true;
        form.setAttribute('aria-busy', 'true');
        status.textContent = form.dataset.pending;
        const controller = new AbortController();
        let timer = null;
        try {
          const cfToken = window.bbCaptcha ? await window.bbCaptcha.token() : '';
          timer = setTimeout(() => controller.abort(), 15000);
          const response = await fetch(form.action, {
            method: 'POST',
            mode: 'cors',
            credentials: 'omit',
            headers: { 'Content-Type': 'application/json' },
            signal: controller.signal,
            body: JSON.stringify({
              email: email.value.trim(),
              consent: true,
              // Testo e versione del consenso mostrati al cliente, per documentare la scelta (art. 7 GDPR).
              consent_text: (consent.closest('label')?.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 600),
              consent_version: form.dataset.consentVersion || '2026-09-29',
              source: form.dataset.source,
              website: form.querySelector('[name="website"]')?.value || '',
              ...(cfToken ? { cf_turnstile: cfToken } : {})
            })
          });
          const data = await response.json();
          if (!response.ok || data.ok !== true) throw new Error('Newsletter request failed');
          fields.hidden = true;
          status.textContent = '';
          success.hidden = false;
          email.value = '';
          consent.checked = false;
          success.focus();
        } catch (error) {
          status.textContent = error && error.name === 'BBCaptchaError' ? error.message : form.dataset.error;
        } finally {
          clearTimeout(timer);
          busy = false;
          submit.disabled = false;
          form.removeAttribute('aria-busy');
        }
      });
      submit.disabled = false;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, { once: true });
  else bind();
  document.addEventListener('shopify:section:load', bind);
})();
